import { BaseModel } from './base';

export class HazardIncidentCategory extends BaseModel {
  IncidentcategoryName: string;
  SubscriberId: string;
  SiteId: string;
  id: string;
}
